"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ExpensesOverview = _interopRequireDefault(require("./ExpensesOverview"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var _default = _ExpensesOverview["default"];
exports["default"] = _default;